// extracted by mini-css-extract-plugin
module.exports = {"player":"VideoPlayer_player__1EHYK","container":"VideoPlayer_container__32UUc"};